'use client';

import { cn } from 'ui';

export const DashboardLayoutContainer = ({
  children,
  pathname,
}: {
  children: React.ReactNode;
  pathname: string;
}) => {
  return (
    <div
      className={cn('space-y-8 md:space-y-0 w-full flex flex-col', {
        'bg-stone-100 space-y-0': pathname?.includes('settings'),
      })}
    >
      {children}
    </div>
  );
};
